import { React } from "react";
import { Card } from "antd";
import Slider from "react-slick";
import { Button } from "../../../components";
import { sliderSettings } from "../config";

const tabs = [
  {
    name: "Soccer",
    active: true
  },
  {
    name: "BasketBall",
    active: false
  },
  {
    name: "Rugby",
    active: false
  },
  {
    name: "Cricket",
    active: false
  },
  {
    name: "Tennis",
    active: false
  },
  {
    name: "Soccer",
    active: true
  },
  {
    name: "BasketBall",
    active: false
  },
  {
    name: "Rugby",
    active: false
  },
  {
    name: "Cricket",
    active: false
  },
  {
    name: "Tennis",
    active: false
  },
];

const NavigationTabs = () => {
  return (
    <Card style={{padding: 20, borderRadius: 10}}>
      <Slider {...sliderSettings}>
        <div></div>
        {tabs.map((item, index) => (
          <div key={index}>
            <Button
              type="primary"
              className={`mt-0 primary-color ${item.active ? "button-quad" : "button-transparent-quad"}`}
              title={item.name}
              style={{
                height: "50px",
                borderRadius: "30px",
                paddingLeft: "2.5em",
                paddingRight: "2.5em",
              }}
            />
          </div>
        ))}
      </Slider>
    </Card>
  );
};

export default NavigationTabs;